import { bus } from "@/main";
import { validateCredentials } from "@/data/authentication";
import Router from 'vue-router'

export default {
	name: "LoginPage",
	data() {
		return {
			form: {
				username: "",
				password: "",
			},
			isLoading: false,
		}
	},
	created() {
	},
	computed: {
		pageUrl: function() {
			return location.href;
		}
	},
	watch: {
	},
	methods: {
		async logIn() {
			this.isLoading = true;
			const response = await validateCredentials(this.form.username, this.form.password);
			if(response) {
				bus.$emit('notification', "Log In efetuado com Sucesso!")
				setTimeout(() => {
					this.goBack()
				}, 1000);
			} else {
				bus.$emit('notification', "⚠️ Log In Incorreto!")
			}
		},
		goBack() {
			this.$router.go(-1)
		}
	}
}



// WEBPACK FOOTER //
// ./src/components/pages/login/login.page.js